import React from "react";
import "./BetList.scss";

const BetList = () => {
  return <p className="empty-b-text-v-bc">No bets to show</p>;
};
export { BetList };
